export default { MODULE_NAME: 'login' };
